import React, { Component } from 'react';
import {reduxForm, Field} from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import withAuthControl from '../auth/Auth';
import validate from './Validations/submitValidationsVineyardTypesForm'

import SaveStepButton from './SaveStepButton';
import TopScrolleable from './TopScrolleable.js';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import CustomAlert from './CustomAlert.js';
import Whatsapp from './WhatsappButton.js';
import RenderField from './RenderField';

class VineyardTypesForm extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_vineyard_types" description="Vineyard Types"/>
                        <div className="show-desktop">
                            <Whatsapp phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                            <SaveStepButton/>
                        </div>
                    </div>
                    <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.setVineyardTypes)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {error && <CustomAlert bsStyle="danger" message={error}/>}
                            <div className="col-md-12 col-lg-12">
                                <h4>Común</h4>
                                <div className="form-group">
                                    <Field className="form-control" name="common_vineyards" autoComplete="off" component={RenderField} type="number" label="Ingresar cantidad de quintales"/>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-12">
                                <h4>Varietal</h4>
                                <div className="form-group">
                                    <Field className="form-control" name="varietal_vineyards" autoComplete="off" component={RenderField} type="number" label="Ingresar cantidad de quintales"/>
                                </div>
                            </div>
                            <div className='col-md-12 col-lg-12 text-center'>
                                <p>Conocé <a href="https://www.ftyc.gob.ar/clasificacion-de-vinedos-cosecha/" target="_blank">aquí</a> la clasificación de tu uva</p>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                            <Whatsapp phone={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_number", defaultMessage: "542612554220"})}
                                    text={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_text", defaultMessage: "Tengo+una+consulta"})}
                                    value={this.context.intl.formatMessage({
                                        id:"app.step_sms_whatsapp_label", defaultMessage: "261-2554-220"})}
                                    gaEvent="true" gaCategory="CallToAction" gaAction="WhatsApp Tapping"/>
                            <FormattedHTMLMessage id="app.whatsapp_timetable" description="Wp timetable"/>
                            <SaveStepButton/>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

VineyardTypesForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

VineyardTypesForm = TopScrolleable(VineyardTypesForm);

VineyardTypesForm = reduxForm({
    form: 'VineyardTypesForm', // a unique name for this form
})(VineyardTypesForm);

VineyardTypesForm = withAuthControl(VineyardTypesForm);

export default VineyardTypesForm;


/** WEBPACK FOOTER **
 ** ./src/components/VineyardTypesForm.js
 **/